import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", "em;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
var Wrapper = styled.div(_templateObject());
var StyledIcon = styled(Icon)(_templateObject2(), 6 / 14);
/**
 * @example ./__docs__/ElementWithIcon.md
 */

export function ElementWithIcon(_ref) {
  var children = _ref.children,
      iconName = _ref.iconName,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 13 : _ref$iconSize,
      iconWidth = _ref.iconWidth,
      iconHeight = _ref.iconHeight,
      _ref$wrapperAs = _ref.wrapperAs,
      wrapperAs = _ref$wrapperAs === void 0 ? 'div' : _ref$wrapperAs;
  return React.createElement(Wrapper, {
    as: wrapperAs
  }, children, React.createElement(StyledIcon, {
    name: iconName,
    size: iconSize,
    width: iconWidth,
    height: iconHeight
  }));
}